import { useState } from "react";

import { getUpdatedIdeaHistory } from "../helpers/getUpdateIdeaHistory";
import { isEmptyHistory } from "../helpers/isEmptyHistory";

export const useUndoResetIdea = (getIdea, setIdea, currentTab, type, reversed, setInvertedIdea) => {
  const [ideaHistoryReset, setIdeaHistoryReset] = useState(null);
  const [changedTab, setChangedTab] = useState(null);

  const undoResetIdea = () => {
    const currentIdea = getIdea();
    const updatedIdea = { ...currentIdea, ...ideaHistoryReset };

    reversed ? setInvertedIdea(updatedIdea) : setIdea(updatedIdea);

    setIdeaHistoryReset(null);
    setChangedTab(null);
  };

  const updateHistory = (idea) => {
    const { history, tab } = getUpdatedIdeaHistory(idea, currentTab, type);

    if (!isEmptyHistory(history, tab)) {
      setChangedTab(tab);
      setIdeaHistoryReset(history);
    }
  };

  const checkedTab = changedTab === currentTab;

  return {
    checkedTab,
    updateHistory,
    undoResetIdea,
  };
};
